/* ================================================================ */
// PAGE CONTAINER | Page.jsx
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
import React, {useState, useEffect, useRef, Suspense} from 'react';
import PropTypes, { arrayOf } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
// Actions
import { fetchPages } from '../../actions/Data/Content';
// Selectors
import { getPage, getPageTypes, getLoadingStatus } from '../../selectors/Data';
// Hooks
import useReactRouter from 'use-react-router';
// Material UI
import makeStyles from '@material-ui/styles/makeStyles';
import Collapse from '@material-ui/core/Collapse';
import Fade from '@material-ui/core/Fade';
import Fab from '@material-ui/core/Fab';
import Icon from '@material-ui/core/Icon';
import CircularProgress from '@material-ui/core/CircularProgress';
import Skeleton from '@material-ui/lab/Skeleton';
// Constants
import {AlignmentTypes, NavigationTypes, MenuTypes} from '@myglobe/core/dist/types';
// > Async
const Story = React.lazy(()=>import('./Story'));
/* ========================================== */
// Constants
/* ========================================== */
const PageTypes = {
    STATIC: 'static',
    STORY: 'story'
};
/* ========================================== */
// Style Settings
/* ========================================== */
const useStyles = makeStyles(theme => ({
    collapseWorkaroundContainer: {
        width: '0px',
        // Override stupid mui element style prop
        height: '100% !important',
        transitionProperty: 'width'
    },
    collapseWorkaroundWrapper: {
        height: 'inherit'
    },
    collapseWorkaroundEntered: {
        width: '100%'
    },
    collapseWorkaroundHidden: {
        width: '0px'
    },
    root: {
        position: 'relative',
        width: '100%',
        height: '100%',
        transition: 'width 500ms cubic-bezier(0.215, 0.610, 0.355, 1.000)',
        //background: theme.palette.background.default
    },
    closeButton: {
        zIndex: 10,
        backgroundColor: theme.palette.secondary.contrastText,
        color: theme.palette.secondary.main,
        position: 'absolute',
        width: '3.5rem',
        height: '3.5rem',
        right: '-2.25rem',
        top: '50%'
    }
}));
/* ========================================== */
/**
 * Page
 * ----
 * Page container for static and story pages
 *
 * @param {object} props component properties
 * @param {string} props.align alignment setting <'left' | 'right' | 'top' | 'bottom'>
 * @param {string} props.slug router match param value
 * @param {object} props.pageConfig page data retrieved from store
 * @param {boolean} isVisible initial expanded state
 */
const Page = (props) => {
    const classes = useStyles();
    const {
        align,
        slug,
        isVisible,
        isExpandable,
        pageConfig,
        pageTypes,
        children,
        storyProps,
        ...others
    } = props;
    const {history} = useReactRouter();
    //const {category, page} = match.params;
    // Handle story component loading if detect type
    // Get page data
    const type = pageConfig?.type.toLowerCase() || PageTypes.STATIC;
    const content = pageConfig?.content || '';
    const style = pageConfig?.style || {};
    // Get page from slug map of category
    //const currentPage = (category) ? slugMap[category] : slugMap['home'];
    //const visible = !isExpandable || isExpandable && isVisible;
    console.log('PAGE CHILDREN',children)
    /* ======================== */
    // RENDER
    /* ======================== */
    const slideDirection = (align === AlignmentTypes.LEFT || align === AlignmentTypes.RIGHT) ? align : align === AlignmentTypes.TOP ? 'down' : 'up';
    console.debug(`${Page.displayName} | `, 'Render -', others, 'slug:', slug, 'pageConfig:', pageConfig, 'pageTypes:', pageTypes, 'type:', type, 'slideDirection:', slideDirection);
    return (
        /*<Collapse
            classes={{
                container: classes.collapseWorkaroundContainer,
                wrapper: classes.collapseWorkaroundWrapper,
                entered: classes.collapseWorkaroundEntered,
                hidden: classes.collapseWorkaroundHidden
            }}
            mountOnEnter
            unmountOnExit
            direction={slideDirection}
            in={isVisible}
            timeout={{enter: 500, exit: 500}}
        >*/
            <div className={classes.root}>
                {/*visible && (
                    <Suspense fallback={<CircularProgress />}>
                        <Story key="story-container" category={category} />
                    </Suspense>
                )*/}
                <Suspense fallback={<Skeleton variant="rect" animation="wave" width="50em" height="100%" />}>
                    {pageTypes.includes(PageTypes.STORY) && <Story isOpen={type === PageTypes.STORY} slug={slug} style={style} storyProps={storyProps} />}
                    {/*<Fade in={type === PageTypes.STATIC} mountOnEnter unmountOnExit>
                        <div dangerouslySetInnerHTML={{__html: content}} style={style} />
                    </Fade>*/}
                    {children}
                </Suspense>
            </div>
        //</Collapse>
    );
};
/* ======================== */
// PROPS
/* ======================== */
Page.propTypes = {
    screen: PropTypes.shape({
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired
    }),
    align: PropTypes.oneOf(Object.values(AlignmentTypes)),
    slug: PropTypes.string,
    pageConfig: PropTypes.shape({
        uuid: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        type: PropTypes.oneOf(Object.values(PageTypes)).isRequired,
        content: PropTypes.string,
        style: PropTypes.object
    }),
    pageTypes: PropTypes.arrayOf(PropTypes.oneOf(Object.values(PageTypes))),
    isVisible: PropTypes.bool,
    isExpandable: PropTypes.bool
};
Page.defaultProps = {
    align: AlignmentTypes.LEFT,
    slug: '',
    isVisible: false,
    isExpandable: false
};
Page.displayName = 'Page';
/* ========================================== */
// Redux
/* ========================================== */
const mapStateToProps = (store, props) =>{
    //const getActivePage = getPage(props.category);
    return {
        isLoading: getLoadingStatus(store, 'pages'),
        pageConfig: getPage(store, props.slug),
        pageTypes: getPageTypes(store)
    };
};
const mapDispatchToProps = dispatch => {
    return bindActionCreators(Object.assign({fetchPages, dispatch}), dispatch);
};
/* ========================================== */
// Export
/* ========================================== */
export default connect(mapStateToProps, mapDispatchToProps)(Page);
/*export default connect(mapStateToProps, mapDispatchToProps)(React.memo(Page, areEqual));

function areEqual(prevProps, nextProps) {
    console.log('PAGE CHECK', prevProps, nextProps);
    return (
        !isNullOrUndefined(prevProps.page) &&
        !isNullOrUndefined(nextProps.page) &&
        prevProps.page.id === nextProps.page.id &&
        prevProps.category === nextProps.category
    );
}*/